<template>
  <div>
    <div id="list_page">
      <div class="header-nav">
        <a class="tab-item" :class="{active: v.colId == ptypeId}" v-for="(v, i) in menu_list" :key="i" @click="tabHandle(v)">{{v.cnName}}</a>
      </div>
      <div class="nav-wrap">
        <div class="nav-title">
          <span v-show="v.colId == ptypeId" v-for="(v, i) in menu_list" :key="i">{{v.cnName}}</span>
        </div>
      </div>
      <div class="project-wrap project-mobile">
        <project-list ref="porlist" :colid="ptypeId"></project-list>
      </div>
      
    </div>
  </div>
</template>

<script>
import {getColumns} from '@/api/home'
import ProjectList from '../../components/ProjectList.vue'

export default {
  components: { ProjectList },
  data() {
    return {
      menu_list: [],
      ptypeId: '',
      title: ''
    }
  },
  mounted() {
    this.ptypeId = this.$route.params.pid
    this.$refs.porlist.loadData(this.ptypeId)
     getColumns(this.$parent.$route.params.cid).then(res => {
      if (res) {
        this.menu_list = res[0].subList
        if (this.menu_list.length > 0) {
          this.title = this.menu_list.find(item => {
            return item.colId == this.ptypeId
          }).cnName
        }
      }
    })
  },
  methods: {
    tabHandle(pData) {
      this.$router.push(`${pData.colId}`)
      this.ptypeId = pData.colId
      this.title = pData.cnName
      this.$refs.porlist.loadData(pData.colId)
    }
  }
}
</script>

<style lang="scss" scoped>
  .project-wrap {
        padding: 0 rem(100) rem(100) rem(75);
        
  }
  @media only screen and (min-width: 768px) {
    // #list_page {
    //   padding: 0 rem(75) rem(100) rem(75);
    // }
    .nav-wrap {
      padding: 0 rem(135) 0 rem(75);
    }
  }
  @media only screen and (max-width: 768px) {
    // #list_page {
    //   padding: 0 .575rem 1rem .575rem;
    // }
    .battle-tab {
      padding-top: .75rem;
    }
  }
</style>